import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import img from "../../img/Rs.png";
const TangentialPolarBar = ({
  values = [2, 1.2, 2.4, 3.6],
  labels = ["a", "b", "c", "d"],
  colors = ["#526FD6", "#31e649", "#e63131"],
  title = "",
  height = "500px",
  fontSize = "12px",

  // Center image
  centerImage = img,
  centerImageSize = 60,
}) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    const chart = echarts.init(chartRef.current);

    const option = {
      title: {
        text: title,
        left: "center",
        top: 10,
        textStyle: {
          fontSize: fontSize,
          fontWeight: 600,
        },
      },

      polar: {
        radius: ["8%", "70%"],
      },

      angleAxis: {
        max: Math.max(...values),
        startAngle: 75,

        axisLine: {
          show: false,
        },

        axisTick: {
          show: true,
        },

        axisLabel: {
          show: true,
        },
        grid: {
          left: "1%",
          right: "1%",
          bottom: "15%",
          containLabel: true,
        },
        splitLine: {
          show: true,
        },
      },
      label: {
        show: false,
        position: "middle",

        formatter: (params) => {
          return `${labels[params.dataIndex]}: ${params.value}`;
        },

        color: "#fff",
        fontSize: 12,
        fontWeight: "600",
      },
      radiusAxis: {
        type: "category",
        data: labels,

        axisLine: {
          show: true,
        },

        axisTick: {
          show: true,
        },

        axisLabel: {
          show: true,
        },

        splitLine: {
          show: true,
        },
      },

      tooltip: {
        trigger: "item",
        formatter: (params) => {
          return `
            <strong>${params.name}</strong><br/>
            Value: ${params.value}
          `;
        },
      },

      series: [
        {
          type: "bar",
          coordinateSystem: "polar",

          data: values.map((value, index) => ({
            value,

            itemStyle: {
              color: colors[index % colors.length],
            },
          })),

          label: {
            show: false,
            position: "middle",

            formatter: (params) => {
              return `${labels[params.dataIndex]}: ${params.value}`;
            },

            color: "#fff",
            fontSize: "12px",
            fontWeight: "600",
          },

          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0, 0, 0, 0.25)",
            },
          },
        },
      ],

      // ==============================
      // CENTER IMAGE
      // ==============================
      graphic: centerImage
        ? {
            type: "image",

            left: "center",
            top: "middle",

            z: 100,

            style: {
              image: centerImage,

              width: centerImageSize,
              height: centerImageSize,

              // Makes sure the image stays centered
              x: -centerImageSize / 2,
              y: -centerImageSize / 2,
            },
          }
        : undefined,

      animation: true,
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [values, labels, colors, title, centerImage, centerImageSize]);

  return (
    <div
      // className="border border-dark "
      notMerge={true}
      ref={chartRef}
      style={{
        width: "200px",
        height,
      }}
    />
  );
};

export default TangentialPolarBar;
